import statLabelMap from '../data/statLabelMap';

const noPercent = ["ElementalATK", "FlatBoost", "FlatATK", "FlatDEF", "FlatHP"]

const renderStats = (statsInput) => {
    //Normalize stats into an array in case there's only one
    const statsArray = Array.isArray(statsInput)
      ? statsInput
      : Object.entries(statsInput).map(([key, { value, target }]) => ({
          key,
          value,
          target,
          stackCount : 1,
          of : null,
          per : null,
          cap : null,
        }));
  
    const listItems = [];
    for (let i = 0; i < statsArray.length; i++) {
      const { key, value, target, stackCount, of, per, cap } = statsArray[i];
      listItems.push(
        <li key={`${key}-${i}`} className="statListItem">
          <strong>
            {key === 'DMGTaken' ? <span>Enemy </span> : ""}
            {target?.element && <span>{target.element} </span>}
            {target?.name && <span>{target.name} </span>}
            {target?.type && <span>{target.type} </span>}
            {statLabelMap[key] || key}:
            <span className="statValue">+{value}{noPercent.includes(key) ? "" : "%"}</span>
            {of && <span> per {per}{of !== "DEF" ? "% of " : ""}   {statLabelMap[of] || of}</span>}{cap && <span className="dependantCap">(capped at {cap}%)</span>}
            {stackCount > 1 && ` x${stackCount}`}
          </strong>
        </li>
      );
    }
  
    return <ul className="no-bullets statText">{listItems}</ul>;
  };
  
  
  


export default renderStats